// extracted by mini-css-extract-plugin
export default {"reports-wrapper":"MembersOverview_reports-wrapper__sATzT"};